import { SvgIconComponent } from '@mui/icons-material'
import {
  Avatar,
  AvatarProps,
  Box,
  BoxProps,
  LinearProgress
} from '@mui/material'
import React from 'react'

const AvatarWithLoader: React.FC<{
  src: string
  containerProps?: BoxProps
  avatarProps?: AvatarProps
  LoaderIcon?: SvgIconComponent
}> = props => {
  const { src, containerProps, avatarProps, LoaderIcon } = props
  const [loading, setLoading] = React.useState(src !== '')
  const [error, setError] = React.useState(src === '')

  React.useEffect(() => setLoading(true), [src])

  return (
    <Box {...containerProps}>
      <Avatar
        src={src}
        imgProps={{
          onLoad: () => setLoading(false),
          onError: () => {
            setError(true)
            setLoading(false)
          }
        }}
        {...{
          ...avatarProps,
          sx: {
            ...avatarProps?.sx,
            display: loading || error ? 'none' : 'block'
          }
        }}
      />
      {(loading || error) && (
        <Box>
          {LoaderIcon !== undefined && (
            <Avatar src={''} {...avatarProps}>
              <LoaderIcon sx={{ ...avatarProps?.sx }} />
            </Avatar>
          )}
          {LoaderIcon === undefined && <Avatar src={''} {...avatarProps} />}
          {!error && <LinearProgress sx={{ marginTop: 1 }} />}
        </Box>
      )}
    </Box>
  )
}

export default AvatarWithLoader
